// extracted by mini-css-extract-plugin
export default {"genericCard":"Us-z","inline":"Vs-z","mastercard":"Ws-z","discover":"Xs-z","visa":"Ys-z","amex":"Zs-z","active":"_s-z"};